import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  static values = { autoOpen: Boolean }
  connect() { if (this.autoOpenValue) this.open() }
  open() { this.dialogTarget.showModal() }
  close() { this.dialogTarget.close() }
  backdrop(event) {
    if (event.target !== this.dialogTarget) return
    const box = this.dialogTarget.getBoundingClientRect()
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close()
  }
  disconnect() { if (this.hasDialogTarget) this.dialogTarget.close() }
}
